<div class="au-shell">

  <!-- scanlines -->
  <div class="au-scanlines"></div>

  <!-- ══ HEADER ══ -->
  <!-- mat-dialog-title on a zero-size hidden span so Material's margin doesn't clip our header -->
  <span mat-dialog-title class="au-dialog-title-anchor"></span>

  <div class="au-header">

    <!-- left accent stripe -->
    <div class="au-header__stripe"></div>

    <!-- hero icon -->
    <div class="au-header__hero">
      <div class="au-header__hero-ring">
        <mat-icon>person_add</mat-icon>
      </div>
      <div class="au-header__hero-pulse"></div>
    </div>

    <!-- title block -->
    <div class="au-header__text">
      <span class="au-header__eyebrow">
        <span class="au-header__eyebrow-dot"></span>
        ADMIN CONSOLE · NEW AGENT
      </span>
      <span class="au-header__title">{{ 'ADMIN_ADD_USER_VIEW.TITLE' | translate }}</span>
      <span class="au-header__sub">{{ 'ADMIN_ADD_USER_VIEW.DESCRIPTION' | translate }}</span>
    </div>

    <!-- close -->
    <button class="au-close-btn" mat-dialog-close type="button" aria-label="Close">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- ══ BODY ══ -->
  <div mat-dialog-content class="au-body">
    <form class="au-form" #dialogForm="ngForm">

      <!-- row 1: username + password -->
      <div class="row g-3">

        <div class="col-12 col-sm-6">
          <div class="au-field-group">
            <label class="au-label">
              <mat-icon>alternate_email</mat-icon>
              {{ 'ADMIN_ADD_USER_VIEW.USERNAME_INPUT.PLACEHOLDER' | translate }}
            </label>
            <mat-form-field appearance="outline" class="au-field">
              <input matInput cdkFocusInitial type="text"
                     [(ngModel)]="user.username" name="username" required />
              <button mat-icon-button matSuffix *ngIf="user.username"
                      [attr.aria-label]="'BUTTON.CLEAR' | translate"
                      (click)="user.username = ''">
                <mat-icon>close</mat-icon>
              </button>
              <mat-hint>{{ 'ADMIN_ADD_USER_VIEW.USERNAME_INPUT.HINT' | translate }}</mat-hint>
              <mat-error>{{ 'ADMIN_ADD_USER_VIEW.USERNAME_INPUT.ERROR' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-12 col-sm-6">
          <div class="au-field-group">
            <label class="au-label">
              <mat-icon>lock</mat-icon>
              {{ 'ADMIN_ADD_USER_VIEW.PASSWORD_INPUT.PLACEHOLDER' | translate }}
            </label>
            <mat-form-field appearance="outline" class="au-field">
              <input matInput [type]="showPwdTxt ? 'text' : 'password'"
                     [(ngModel)]="user.password" name="password" required />
              <button mat-icon-button matSuffix
                      (click)="showPwdTxt = !showPwdTxt"
                      [attr.aria-label]="'ADMIN_ADD_USER_VIEW.PASSWORD_INPUT.BUTTON_HIDE_ARIA_LABEL' | translate"
                      [attr.aria-pressed]="showPwdTxt">
                <mat-icon>{{ showPwdTxt ? 'visibility_off' : 'visibility' }}</mat-icon>
              </button>
              <mat-hint>{{ 'ADMIN_ADD_USER_VIEW.PASSWORD_INPUT.HINT' | translate }}</mat-hint>
              <mat-error>{{ 'ADMIN_ADD_USER_VIEW.PASSWORD_INPUT.ERROR' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <!-- row 2: email + phone -->
        <div class="col-12 col-sm-6">
          <div class="au-field-group">
            <label class="au-label">
              <mat-icon>email</mat-icon>
              {{ 'ADMIN_ADD_USER_VIEW.EMAIL_INPUT.PLACEHOLDER' | translate }}
            </label>
            <mat-form-field appearance="outline" class="au-field">
              <input matInput type="email"
                     [(ngModel)]="user.email" name="email" required email="email" />
              <button mat-icon-button matSuffix *ngIf="user.email"
                      [attr.aria-label]="'BUTTON.CLEAR' | translate"
                      (click)="user.email = ''">
                <mat-icon>close</mat-icon>
              </button>
              <mat-hint>{{ 'ADMIN_ADD_USER_VIEW.EMAIL_INPUT.HINT' | translate }}</mat-hint>
              <mat-error>{{ 'ADMIN_ADD_USER_VIEW.EMAIL_INPUT.ERROR' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="col-12 col-sm-6">
          <div class="au-field-group">
            <label class="au-label">
              <mat-icon>phone_iphone</mat-icon>
              {{ 'ADMIN_ADD_USER_VIEW.PHONE_NUMBER_INPUT.PLACEHOLDER' | translate }}
            </label>
            <mat-form-field appearance="outline" class="au-field">
              <input matInput type="text"
                     [(ngModel)]="user.phoneNumber" name="phoneNumber" required />
              <button mat-icon-button matSuffix *ngIf="user.phoneNumber"
                      [attr.aria-label]="'BUTTON.CLEAR' | translate"
                      (click)="user.phoneNumber = ''">
                <mat-icon>close</mat-icon>
              </button>
              <mat-hint>{{ 'ADMIN_ADD_USER_VIEW.PHONE_NUMBER_INPUT.HINT' | translate }}</mat-hint>
              <mat-error>{{ 'ADMIN_ADD_USER_VIEW.PHONE_NUMBER_INPUT.ERROR' | translate }}</mat-error>
            </mat-form-field>
          </div>
        </div>

      </div>

      <!-- error banner -->
      <div class="au-error-banner" *ngIf="errorMessage">
        <mat-icon>warning_amber</mat-icon>
        <span>{{ errorMessage }}</span>
      </div>

    </form>
  </div>

  <!-- ══ FOOTER ══ -->
  <div mat-dialog-actions class="au-footer">
    <!-- progress dots — visual flair -->
    <div class="au-footer__dots">
      <span class="au-dot" [class.au-dot--filled]="user.username"></span>
      <span class="au-dot" [class.au-dot--filled]="user.password"></span>
      <span class="au-dot" [class.au-dot--filled]="user.email"></span>
      <span class="au-dot" [class.au-dot--filled]="user.phoneNumber"></span>
    </div>

    <div class="au-footer__actions">
      <button class="au-btn au-btn--cancel" mat-dialog-close type="button">
        <mat-icon>chevron_left</mat-icon>
        <span>{{ 'BUTTON.CANCEL' | translate }}</span>
      </button>
      <button class="au-btn au-btn--save" type="button"
              (click)="addUser()" [disabled]="!dialogForm.valid">
        <mat-icon>check</mat-icon>
        <span>{{ 'BUTTON.SAVE' | translate }}</span>
      </button>
    </div>
  </div>

</div>
